import { useContext, useEffect } from 'react';
import {
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  Typography,
} from '@mui/material';
import { Controller, useForm } from 'react-hook-form';
import { removeFalseKeys } from 'utils/functions';
import { DocumentosContext } from 'contexts/DocumentosContext';
import { AuthContext } from 'contexts/AuthContext';
import { useDialog } from 'components/Modals';
import Loader from 'components/Loader';
import Button from 'components/Button';
import moment from 'moment';

const RetornoModal = ({ item, reload }) => {
  const defaultValues = { type: '87', item: null };
  const { closeDialog } = useDialog();
  const { user } = useContext(AuthContext);
  const { getLoading, getDocumentoItens, postLoading, postDocumento } =
    useContext(DocumentosContext);
  const { control, handleSubmit, setValue } = useForm({ defaultValues });
  const styles = {
    radioContainer: { flexDirection: 'row' },
    radio: { flex: 1, m: 0 },
  };

  useEffect(() => {
    getDocumentoItens({
      isItem: true,
      id: [item?.id],
      cb: (res) => setValue('item', res?.[0] || null),
    });
  }, []);

  const onSubmit = (values) => {
    const itm = {
      ...values?.item,
      sequencia: 1,
      Origens: [{ documento_item_org_id: values?.item?.id }],
    };
    delete itm?.UnidadeMedida;
    delete itm?.documento_id;
    delete itm?.sp_custo;
    delete itm?.Produto;
    delete itm?.vinculo;
    delete itm?.id;

    const data = {
      Documento: {
        especie_id: 10,
        users_id: user?.id,
        filial_id: user?.filial_id,
        cadastro_id: item?.cliente_id,
        dtemissao: moment().format('YYYY-MM-DD HH:mm:ss'),
        natureza_operacao_id: Number(values?.type),
      },
      Itens: [itm],
    };

    removeFalseKeys(data);

    const cb = () => {
      closeDialog();
      if (Boolean(reload)) reload();
    };

    postDocumento({ data, cb });
  };

  if (getLoading) {
    return <Loader />;
  }

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography variant="h6" align="center">
          Informações Gerais
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Controller
          control={control}
          name="type"
          render={({ field }) => (
            <RadioGroup {...field} sx={styles?.radioContainer}>
              <FormControlLabel
                value="87"
                control={<Radio />}
                label="Retorno em Garantia"
                sx={styles?.radio}
              />
              <FormControlLabel
                value="99"
                control={<Radio />}
                label="Retorno para Troca em Garantia"
                sx={styles?.radio}
              />
            </RadioGroup>
          )}
        />
      </Grid>
      <Grid item xs={12} textAlign="center">
        <Button
          variant="contained"
          color="primary"
          onClick={handleSubmit(onSubmit)}
          loading={postLoading}
        >
          Enviar
        </Button>
      </Grid>
    </Grid>
  );
};

export default RetornoModal;
